import { CheckIcon, CloseIcon, CopyIcon, DeleteIcon, EditIcon } from '@chakra-ui/icons';
import {
    Button,
    Link as ChakraLink,
    Flex,
    HStack,
    IconButton,
    Input, Select,
    Table, Tbody,
    Td,
    Text, Th, Thead, Tr,
    VStack,
    useColorModeValue,
    useDisclosure
} from '@chakra-ui/react';
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CampanhasController from "controllers/Campanhas/CampanhasController";
import FichasController from "controllers/Fichas/FichasController";
import OperacoesController from "controllers/Operacoes/OperacoesController";
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  InputGroup,
  InputLeftAddon,
} from '@chakra-ui/react'

export function DuplicateModal({ audit, getData }) {
  const newNameComplement = ' - cópia'
  const [value, setValue] = useState(audit.Nome + newNameComplement)
  
  const { isOpen, onOpen, onClose } = useDisclosure()

  async function handleDuplicate() {
    const newAudit = {
      audit_id: audit.id,
      audit_name: value
    }

    const response = await FichasController.DuplicateFicha(newAudit)

    if(response) {
      getData()
      onClose()
      setValue('')
    }
  }

  return (
    <>
      <IconButton
        mr={2}
        onClick={() => onOpen()}
        icon={<CopyIcon />}
      />

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Duplicar ficha</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <InputGroup>
              <InputLeftAddon>Novo nome</InputLeftAddon>
              <Input 
                value={value}
                onChange={(event) => setValue(event.target.value)}
                placeholder="Digite um novo nome..." 
              />
            </InputGroup>
          </ModalBody>

          <ModalFooter>
            <Button variant='ghost' mr={3} onClick={onClose}>
              Cancelar
            </Button>
            <Button 
              colorScheme='blue' 
              disabled={value === ''} 
              onClick={handleDuplicate}
            >
              Duplicar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}